import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyStatus, ListCompaniesParams } from 'src/app/core/companies.service';
import { UtilsService } from 'src/app/core/utils.service';
import {
  COMPANY_ID_LABEL,
  BUSINESS_NAME_LABEL,
  VAT_LABEL,
  STATUS_LABEL,
  SALES_NETWORK_ID_LABEL,
  PRODUCT_CATEGORY_LABEL,
  AGREEMENT_LABEL,
  FORM_ORIGIN_FIELD_LABEL,
} from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-companies-filters',
  templateUrl: './companies-filters.component.html',
  styleUrls: ['./companies-filters.component.scss'],
})
export class CompaniesFiltersComponent {
  @Input() filters?: ListCompaniesParams;
  @Output() filter_clear: EventEmitter<ListCompaniesParams> = new EventEmitter<ListCompaniesParams>();

  constructor(private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        if (!this.filters) return false;
        return this.filters[k as keyof typeof this.filters] != null;
      });
    }
    return [];
  }

  getLabelByKey(key: string): string {
    const available_keys: string[] = Object.keys(this.filters || []);
    console.log(key);
    console.log(available_keys);
    switch (key) {
      case available_keys[0]:
        return COMPANY_ID_LABEL;
      case available_keys[1]:
        return BUSINESS_NAME_LABEL;
      case available_keys[2]:
        return VAT_LABEL;
      case available_keys[3]:
        return STATUS_LABEL;
      case available_keys[4]:
        return SALES_NETWORK_ID_LABEL;
      case available_keys[5]:
        return PRODUCT_CATEGORY_LABEL;
      case available_keys[6]:
        return AGREEMENT_LABEL;
      case available_keys[7]:
        return FORM_ORIGIN_FIELD_LABEL;
      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    const available_keys: string[] = Object.keys(this.filters || []);
    switch (key) {
      case available_keys[0]:
        return this.filters?.company_id || '-';
      case available_keys[1]:
        return this.filters?.business_name || '-';
      case available_keys[2]:
        return this.filters?.vat || '-';
      case available_keys[3]:
        return this.getCompanyStatusLabel(this.filters?.status);
      case available_keys[4]:
        return this.filters?.sales_network_id || '-';
      case available_keys[5]:
        return this.filters?.product_category || '-';
      case available_keys[6]:
        return this.filters?.agreement || '-';
      case available_keys[7]:
        return this.filters?.origin || '-';
      default:
        return '';
    }
  }

  getCompanyStatusLabel(status?: CompanyStatus): string {
    if (!status) return '';
    return this.utils_service.getCompanyStatusLabel(status);
  }
}
